import { Context, Dispatch, useContext, useState } from "react";
import { DropdownMenu as DropdownMenuPrimitive } from "radix-ui";
import ChevronDownIcon from "../../icons/ChevronDownIcon";
import Button from "@/components/bricks/button/Button";
import EditIcon from "../../icons/EditIcon";
import * as Dialog from "@radix-ui/react-dialog";
import {
  QueryFilter,
  FilterPreset,
  QueryFilterEvent,
} from "../../../interfaces/filters";
import { FilterPresetsContext } from "../../../context/FiltersContext";
import FilterPresetsEditModal from "./FilterPresetsEditModal";
import { sortBy } from "lodash";

const DropdownMenu = DropdownMenuPrimitive.Root;
const DropdownMenuContent = DropdownMenuPrimitive.Content;
const DropdownMenuItem = DropdownMenuPrimitive.Item;
const DropdownTrigger = DropdownMenuPrimitive.Trigger;
const DropdownArrow = DropdownMenuPrimitive.Arrow;
const DropdownMenuLabel = DropdownMenuPrimitive.Label;
const DropdownMenuSeparator = DropdownMenuPrimitive.Separator;

export default function FilterPresetsDropdown<Keys>({
  container,
  contextType,
  queryFilterEventContext,
}: {
  container: HTMLElement | null;
  contextType: FilterPreset["type"];
  queryFilterEventContext: Context<Dispatch<QueryFilterEvent<Keys>>>;
}) {
  const filterPresets = useContext(FilterPresetsContext);
  const updateQueryFilters = useContext(queryFilterEventContext);

  const [open, setOpen] = useState(false);

  // business
  // filter filters for the given context
  const contextFilters = filterPresets.filter((f) => f.type === contextType);

  const myFilters = sortBy(
    contextFilters.filter((filterObj) => filterObj.erPersonlig),
    ["navn"],
  );
  const standardFilters = sortBy(
    contextFilters.filter((filterObj) => !filterObj.erPersonlig),
    ["navn"],
  );

  function setFiltersHandler(f: QueryFilter<Keys>[]) {
    updateQueryFilters({
      queryFilter: structuredClone(f),
      event: "replace",
    });
  }

  return (
    <Dialog.Root>
      <DropdownMenu open={open} onOpenChange={(open) => setOpen(open)}>
        <nav
          className={`c-dropdown-menu c-dropdown-menu--filterpresets${
            open ? " is-showing" : ""
          }`}
        >
          <DropdownTrigger className="c-dropdown-menu-trigger" asChild={true}>
            <Button transparent color="secondary" size="sm" onClick={() => {}}>
              Gemte filtre <ChevronDownIcon width={18} />
            </Button>
          </DropdownTrigger>
          <DropdownMenuContent
            className="c-dropdown-menu-content"
            align="end"
            alignOffset={-52}
            sideOffset={3}
          >
            <>
              <DropdownArrow className="c-dropdown-menu-arrow"></DropdownArrow>
              <h3 className="c-dropdown-menu-label h5 w-100 d-flex align-items-center lh-1 py-0 pe-0">
                Gemte filtre
                <Dialog.Trigger
                  aria-label="Rediger gemte filtre"
                  className="btn btn-secondary btn--transparent btn--icon ms-auto tooltip-end"
                  onClick={() => {}}
                >
                  <EditIcon height={14} />
                </Dialog.Trigger>
              </h3>
              <DropdownMenuLabel className="c-dropdown-menu-label  pt-0">
                Mine filtre
              </DropdownMenuLabel>
              {myFilters && myFilters.length > 0 ? (
                myFilters.map((f) => {
                  return (
                    <DropdownMenuItem
                      key={`myFilters-dropDownMenuItem-${f.navn}`}
                      className="c-dropdown-menu-item"
                      onClick={() =>
                        // intentional type cast here
                        setFiltersHandler(f.filter as QueryFilter<Keys>[])
                      }
                    >
                      {f.navn}
                    </DropdownMenuItem>
                  );
                })
              ) : (
                <DropdownMenuItem
                  disabled
                  className="c-dropdown-menu-item bg-light"
                >
                  <i>Ingen gemte filtre</i>
                </DropdownMenuItem>
              )}
              <DropdownMenuSeparator className="c-dropdown-menu-separator" />
              <DropdownMenuLabel className="c-dropdown-menu-label">
                Standardfiltre
              </DropdownMenuLabel>
              {standardFilters && standardFilters.length > 0 ? (
                standardFilters.map((f) => (
                  <DropdownMenuItem
                    key={`myFilters-dropDownMenuItem-${f.navn}`}
                    className="c-dropdown-menu-item"
                    onClick={() => {
                      // intentional type cast here
                      setFiltersHandler(f.filter as QueryFilter<Keys>[]);
                    }}
                  >
                    {f.navn}
                  </DropdownMenuItem>
                ))
              ) : (
                <DropdownMenuItem
                  disabled
                  className="c-dropdown-menu-item bg-light"
                >
                  <i>Ingen gemte filtre</i>
                </DropdownMenuItem>
              )}
            </>
          </DropdownMenuContent>
        </nav>
      </DropdownMenu>
      <FilterPresetsEditModal
        container={container}
        contextType={contextType}
        contextFilters={contextFilters}
      />
    </Dialog.Root>
  );
}
